export const parseEgressIps = (staticIp) => (staticIp ?? '')
    .split(/[\s,]+/)
    .map((ip) => ip.trim())
    .filter((ip) => ip.length > 0);
//# sourceMappingURL=egressIps.js.map